import { render, staticRenderFns } from "./COIForm.vue?vue&type=template&id=0f1e5168&scoped=true&"
import script from "./COIForm.vue?vue&type=script&lang=ts&"
export * from "./COIForm.vue?vue&type=script&lang=ts&"
import style0 from "./COIForm.vue?vue&type=style&index=0&id=0f1e5168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1e5168",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
